<template>
    <div class="overflow-x-clip">
        <router-view />
    </div>
</template>
